import React, { useState, useContext, useEffect, useRef } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { toast } from "react-toastify";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ModalPop from "components/sales/modal/modal";
import { Button } from "react-bootstrap";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import useLatLng from "hooks/uselatlng/uselatlng";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";

const CompetitionMapping = ({
  match,
  history,
  saveCompetitionMapping,
  documentUploadUrlPublic,
  fetchSiteNameUsingLatLong,
  fetchSiteNameResponse = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [successModal, setIsSuccessModal] = useState(false);
  const islatlng = useLatLng();
  const [selfie, setSelfie] = useState("");
  const [selfieUrl, setSelfieUrl] = useState("");
  const [checkSelfieUrl, setCheckSelfieUrl] = useState("");
  const canvasRef = useRef(null);
  const [isAllow, setIsAllow] = useState(false);
  const [retake, setRetake] = useState(true);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    formatted_address: null,
    lat: 0,
    lng: 0,
  });

  const [barrierSelfie, setBarrierSelfie] = useState("");
  const [barrierSelfieUrl, setBarrierSelfieUrl] = useState("");
  const [checkBarrierSelfieUrl, setCheckBarrierSelfieUrl] = useState("");
  const barrierCanvasRef = useRef(null);
  const [retakeBarrier, setRetakeBarrier] = useState(true);

  const [formData, setFormData] = useState({
    site_name: "",
    barrier_installed: "",
    barrier_brand: "",
    other_brand_name: "",
    solution_type: "",
    guard_remarks: "",
    entrance_photo: "",
    barrier_photo: "",
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (
        islatlng?.lat !== undefined &&
        islatlng?.lng !== undefined &&
        islatlng?.lat !== 0 &&
        islatlng?.lng !== 0 &&
        islatlng?.lat !== null &&
        islatlng?.lng !== null
      ) {
        await fetchSiteNameUsingLatLong(islatlng?.lat, islatlng?.lng);
      }
      setIsLoading(false);
    })();
  }, [islatlng]);

  const handleSubmit = async (e) => {
    formData["entrance_photo"] = selfieUrl;
    formData["barrier_photo"] = barrierSelfieUrl;
    e.preventDefault();
    setIsLoading(true);
    const res = await saveCompetitionMapping(formData);
    if (res?.data?.status_code == 200) {
      setIsModal(false);
      setIsSuccessModal(true);
    } else {
      toast.error(res?.data?.message);
    }
    setIsLoading(false);
  };

  const handleModalHide = () => {
    setIsModal(false);
    setFormData({
      site_name: "",
      barrier_installed: "",
      barrier_brand: "",
      other_brand_name: "",
      solution_type: "",
      guard_remarks: "",
      entrance_photo: "",
      barrier_photo: "",
    });
    setSelfie("");
    setSelfieUrl("");
    setCheckSelfieUrl("");
    setBarrierSelfie("");
    setBarrierSelfieUrl("");
    setCheckBarrierSelfieUrl("");
    setRetakeBarrier(true);
    setRetake(true);
  };
  const handleSuccessModalHide = () => {
    setIsSuccessModal(false);
    setFormData({
      site_name: "",
      barrier_installed: "",
      barrier_brand: "",
      other_brand_name: "",
      solution_type: "",
      guard_remarks: "",
      entrance_photo: "",
      barrier_photo: "",
    });
    setSelfie("");
    setSelfieUrl("");
    setCheckSelfieUrl("");
    setBarrierSelfie("");
    setBarrierSelfieUrl("");
    setCheckBarrierSelfieUrl("");
    setRetakeBarrier(true);
    setRetake(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${islatlng?.lat}, ${islatlng?.lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
        );
        if (
          response !== null &&
          response?.data !== null &&
          response?.data?.results?.length > 0 &&
          response?.data?.results[0]?.formatted_address !== null
        ) {
          setMapLocation({
            ...mapLocation,
            formatted_address: response?.data?.results[0]?.formatted_address,
          });
        }
      } catch {
        toast.error("Google Map API failure");
        return;
      }
    };
    if (
      islatlng?.lat !== undefined &&
      islatlng?.lng !== undefined &&
      islatlng?.lat !== 0 &&
      islatlng?.lng !== 0 &&
      islatlng?.lat !== null &&
      islatlng?.lng !== null
    ) {
      fetchData();
    }
  }, [islatlng]);

  const currentDateTimeFormat = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const isPM = hours >= 12;
    const ampm = isPM ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    if (selfie !== "" && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = selfie;

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = "10px Arial";
        ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
        const backgroundHeight = 80;
        ctx.fillRect(
          0,
          canvas.height - backgroundHeight,
          canvas.width,
          backgroundHeight
        );
        ctx.fillStyle = "white";
        const yBase = canvas.height - 70;
        ctx.fillText(
          `lat-long ( ${Number(islatlng?.lat)} , ${Number(islatlng?.lng)} )`,
          10,
          yBase
        );
        ctx.fillText(
          `Image taken at: ${currentDateTimeFormat()}`,
          10,
          yBase + 20
        );

        const maxWidth = canvas.width - 20;
        const lineHeight = 18;
        const address = `Address: ${mapLocation?.formatted_address}`;
        if (
          mapLocation?.formatted_address != null ||
          mapLocation?.formatted_address != undefined
        ) {
          wrapTextAddress(ctx, address, 10, yBase + 40, maxWidth, lineHeight);
        }

        (async () => {
          setIsLoading(true);
          const url = await documentUploadUrlPublic({
            base_64_file: canvas.toDataURL("image/png"),
          });
          if (url) {
            setCheckSelfieUrl(url);
          }
          setIsLoading(false);
        })();
      };
    }
  }, [selfie]);

  useEffect(() => {
    if (barrierSelfie !== "" && barrierCanvasRef.current) {
      const canvas = barrierCanvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = barrierSelfie;

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = "10px Arial";
        ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
        const backgroundHeight = 80;
        ctx.fillRect(
          0,
          canvas.height - backgroundHeight,
          canvas.width,
          backgroundHeight
        );
        ctx.fillStyle = "white";
        const yBase = canvas.height - 70;
        ctx.fillText(
          `lat-long ( ${Number(islatlng?.lat)} , ${Number(islatlng?.lng)} )`,
          10,
          yBase
        );
        ctx.fillText(
          `Image taken at: ${currentDateTimeFormat()}`,
          10,
          yBase + 20
        );
        const maxWidth = canvas.width - 20;
        const lineHeight = 18;
        const address = `Address: ${mapLocation?.formatted_address}`;
        if (mapLocation?.formatted_address) {
          wrapTextAddress(ctx, address, 10, yBase + 40, maxWidth, lineHeight);
        }

        (async () => {
          setIsLoading(true);
          const url = await documentUploadUrlPublic({
            base_64_file: canvas.toDataURL("image/png"),
          });
          if (url) {
            setCheckBarrierSelfieUrl(url);
          }
          setIsLoading(false);
        })();
      };
    }
  }, [barrierSelfie]);

  function wrapTextAddress(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = ctx.measureText(testLine).width;
      if (testWidth > maxWidth && i > 0) {
        ctx.fillText(line, x, y);
        line = words[i] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
  }

  useEffect(() => {
    if (checkSelfieUrl?.file_url !== undefined) {
      setSelfieUrl(checkSelfieUrl?.file_url);
    }
  }, [checkSelfieUrl]);

  useEffect(() => {
    if (checkBarrierSelfieUrl?.file_url !== undefined) {
      setBarrierSelfieUrl(checkBarrierSelfieUrl?.file_url);
    }
  }, [checkBarrierSelfieUrl]);

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  return (
    <Layout
      title={localization.competitionMapping}
      isLoading={isLoading}
      isGoback={true}
    >
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h5>Competition Mapping</h5>
            {/* <div className="row mt-3">
              <div className="col-md-6">
                <button
                  className="btn btn-primary btn-lg"
                  onClick={() => setIsModal(true)}
                >
                  Add new site
                </button>
              </div>
            </div> */}
            {/* Basic Fields */}
            <div className="row mt-4">
              <div className="col-md-6">
                <DropDownInput
                  data={fetchSiteNameResponse}
                  label={localization.siteWithIn500Meter}
                  required
                  getIdValue={(val) => {
                    setFormData({ ...formData, site_name: val.id });
                  }}
                  isStarRequired={true}
                />
              </div>
              <div className="col-md-6">
                <ConstantInput
                  label={localization.barrierInstalled}
                  type="text"
                  required
                  isStarRequired={true}
                  handleChange={(value) => {
                    setFormData({ ...formData, barrier_installed: value });
                  }}
                />
              </div>
            </div>

            {/* Dropdowns */}
            <div className="row">
              <div className="col-md-6">
                <DropDownInput
                  data={[
                    { id: "Parksmart", name: "Parksmart" },
                    { id: "ESSL", name: "ESSL" },
                    { id: "Radius", name: "Radius" },
                    { id: "Neptune", name: "Neptune" },
                    { id: "Other", name: "Other" }
                  ]}
                  label={localization.barrierBrand}
                  required
                  getIdValue={(val) => {
                    setFormData({ ...formData, barrier_brand: val.id });
                  }}
                  isStarRequired={true}
                />
              </div>

              {formData.barrier_brand === "Other" && (
                <div className="col-md-6">
                  <ConstantInput
                    label={localization.otherBrandName}
                    type="text"
                    required
                    isStarRequired={true}
                    handleChange={(value) => {
                      setFormData({ ...formData, other_brand_name: value });
                    }}
                  />
                </div>
              )}

              <div className="col-md-6">
                <DropDownInput
                  data={[
                    { id: "Automatic", name: "Automatic" },
                    { id: "Manual", name: "Manual" },
                  ]}
                  label={localization.solutionType}
                  required
                  getIdValue={(val) => {
                    setFormData({ ...formData, solution_type: val.id });
                  }}
                  isStarRequired={true}
                />
              </div>
            </div>

            {/* TextArea */}
            <div className="row">
              <div className="col-md-12">
                <TextAreaInput
                  inputValue={formData.guard_remarks}
                  className="inline-css scrollbar-styling"
                  rows={4}
                  type="text"
                  label={localization.guardRemarks}
                  required
                  isStarRequired={true}
                  handleChange={(e) =>
                    setFormData({ ...formData, guard_remarks: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <h5 className="mb-3" style={{textAlign: "center"}}>Society entrance with barrier visibility</h5>
              </div>
              <div className="col-md-12">
                <canvas
                  ref={canvasRef}
                  width="400"
                  height="200"
                  style={{
                    display: "none",
                    border: "1px solid black",
                    marginTop: "20px",
                  }}
                ></canvas>
                {selfieUrl !== "" ? (
                  <>
                    <img
                      src={`${selfieUrl}`}
                      alt={""}
                      style={{ maxWidth: "100%" }}
                    />
                    <div
                      className="col-md-12 mt-4 d-flex"
                      style={{ justifyContent: "center" }}
                    >
                      <Button
                        className="btn-sm"
                        onClick={() => {
                          setRetake(true);
                          setSelfieUrl("");
                          setSelfie("");
                        }}
                      >
                        {"Retake"}
                      </Button>
                    </div>
                  </>
                ) : (
                  retake && (
                    <Camera
                      idealFacingMode={"environment"}
                      idealResolution={{ width: 400, height: 200 }}
                      onTakePhoto={(dataUri) => {
                        setIsLoading(true);
                        setSelfie(dataUri);
                        setRetake(false);
                        setIsLoading(false);
                      }}
                    />
                  )
                )}
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-md-12">
                <h5 className="mb-3" style={{textAlign: "center"}}>Closeup of barrier with brand visibility</h5>
              </div>
              <div className="col-md-12">
                <canvas
                  ref={barrierCanvasRef}
                  width="400"
                  height="200"
                  style={{
                    display: "none",
                    border: "1px solid black",
                    marginTop: "20px",
                  }}
                ></canvas>
                {barrierSelfieUrl !== "" ? (
                  <>
                    <img
                      src={`${barrierSelfieUrl}`}
                      alt={""}
                      style={{ maxWidth: "100%" }}
                    />
                    <div
                      className="col-md-12 mt-4 d-flex"
                      style={{ justifyContent: "center" }}
                    >
                      <Button
                        className="btn-sm"
                        onClick={() => {
                          setRetakeBarrier(true);
                          setBarrierSelfieUrl("");
                          setBarrierSelfie("");
                        }}
                      >
                        {"Retake"}
                      </Button>
                    </div>
                  </>
                ) : (
                  retakeBarrier && (
                    <Camera
                      idealFacingMode={"environment"}
                      idealResolution={{ width: 400, height: 200 }}
                      onTakePhoto={(dataUri) => {
                        setIsLoading(true);
                        setBarrierSelfie(dataUri);
                        setRetakeBarrier(false);
                        setIsLoading(false);
                      }}
                    />
                  )
                )}
              </div>
            </div>

            <div
              className="col-md-12 mt-5"
            >
              <Button className="btn btn-success" onClick={handleSubmit}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ModalPop
        title={localization.addNewSite}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="card">
          <div className="card-body"></div>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={successModal}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.siteAddedSuccessfully}</h5>
          <Link
            to={`${baseUrl}/competition-mapping-list`}
            className="btn btn-primary mb-4"
          >
            {"Back to list"} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default CompetitionMapping;
